import React from "react";

const Label = (props) => {
  return (
    <label className="col-sm-2 col-form-label col-form-label-lg">
      <strong>{props.text}</strong>
    </label>
  );
};

export default Label;
